module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "structure-nxt"
  }, [_c('span', {
    staticClass: "red"
  })]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_White"
  }, [_c('span', {
    staticClass: "red CharOverride-12"
  })]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_White"
  }, [_c('span', {
    staticClass: "red CharOverride-12"
  }, [_vm._v("For Jim, always")])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white-center"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "",
      "src": "image/1967-_Jim_&_June_CROPPED.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_White ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-13"
  }, [_vm._v("1967")])]), _vm._v(" "), _c('p', {
    staticClass: "Blue_Quote"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("In your light I learn how to love."), _c('br'), _vm._v("In your beauty, how to make poems."), _c('br'), _vm._v("You dance inside my chest,"), _c('br'), _vm._v("where no one sees you,"), _c('br'), _vm._v("but sometimes I do, and that"), _c('br'), _vm._v("sight becomes this")]), _c('span', {
    staticClass: "noBreak CharOverride-12"
  }), _c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("art.")])]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Blue"
  }, [_vm._v("—Rumi (1207–1273)")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Blue _idGenParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-12"
  }, [_vm._v("Translated by Coleman Barks")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d19c730","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039444.vue
// module id = 72
// module chunks = 0